import {createRouter, createWebHashHistory} from "vue-router";
import store from "../store";
import util from "../common/util";
import HomeView from "../views/newHome/newHome.vue"
// import BindBox from "../views/BindBox/BindBox.vue"
import login from "../views/Login/login.vue"
import register from "../views/Register/register.vue"
import resetPass from "../views/ResetPass/resetPass.vue"
import onePurchase from "../views/onePurchase/onePurchase.vue"
import flashOption from "../views/Flash/flashOption.vue"
import volatilityOption from "../views/Volatility/volatilityOption.vue"
import term from "../views/Home/investment/Term/term.vue"
import spot from "../views/Home/spot/spot.vue"
import futures from "../views/Home/futures/futures.vue"
import mock from "../views/Home/mock/mock.vue"
import futuresData from "../views/Home/futures/futuresData/futuresData.vue"
import copyTraders from "../views/Home/copyTraders/copyTraders.vue"
import appDownload from "../views/Home/appDownload/appDownload.vue"
import investment from "../views/Home/investment/investment.vue"
import fund from "../views/Home/investment/fund/fund.vue"
import fundDetails from "../views/Home/investment/fund/fundDetails/fundDetails.vue"
import termDetail from "../views/Home/investment/Term/detail/detail.vue"
import easyEarn from "../views/Home/investment/easyEarn/easyEarn.vue"
import pledge from "../views/Home/investment/pledge/pledge.vue"
import assets from "../views/Home/assets/assets.vue"
import order from "../views/Home/order/orderView.vue"
import personal from "../views/Home/personal/userManagement.vue"
import help from "../views/Help/help.vue"
import helpFaq from "../views/Help/faq.vue"
import helpAnnouncements from "../views/Help/announcements.vue"
import categories from "../views/Help/categories/categories.vue"
import content from "../views/Help/content/contentView.vue"
import rank from "../views/rank/rank.vue"
import topUp from "../views/Home/assets/topUp/topUp.vue"
import withdraw from "../views/Home/assets/withdraw/withdraw.vue"
import quotes from "@/views/Home/quotes/quotes.vue";

const routes = [
    // {
    //   path: "/",
    //   name: "newHome",
    //   component: newHome,
    // },
    {
        path: "/",
        name: "HomeView",
        component: HomeView,
    },
    // {
    //     path: "/BindBox",
    //     name: "BindBox",
    //     component: BindBox,
    // },
    {
        path: "/login",
        name: "login",
        component: login,
    },
    {
        path: "/register",
        name: "register",
        component: register,
    },
    {
        path: "/resetPass",
        name: "resetPass",
        component: resetPass,
    },
    {
        path: "/onePurchase",
        name: "onePurchase",
        component: onePurchase,
    },
    {
        path: "/flashOption",
        name: "flashOption",
        component: flashOption,
    },
    {
        path: "/volatilityOption",
        name: "volatilityOption",
        component: volatilityOption,
    },
    {
        path: "/term",
        name: "term",
        component: term,
    },
    {
        path: "/spot",
        name: "spot",
        component: spot,
    },
    {
        path: "/futures",
        name: "futures",
        component: futures,
    },
    {
        path: "/mock",
        name: "mock",
        component: mock,
    },
    {
        path: "/HomeView/futures/futuresData",
        name: "futuresData",
        component: futuresData,
    },
    {
        path: "/copyTraders",
        name: "copyTraders",
        component: copyTraders,
    },
    {
        path: "/HomeView/appDownload",
        name: "appDownload",
        component: appDownload,
    },
    {
        path: "/investment",
        name: "investment",
        component: investment,
    },
    {
        path: "/fund",
        name: "fund",
        component: fund,
    },
    {
        path: "/HomeView/investment/fund/fundDetails",
        name: "fundDetails",
        component: fundDetails,
    },
    {
        path: "/HomeView/investment/Term/detail",
        name: "termDetail",
        component: termDetail,
    },
    {
        path: "/easyEarn",
        name: "easyEarn",
        component: easyEarn,
    },
    {
        path: "/pledge",
        name: "pledge",
        component: pledge,
    },
    {
        path: "/HomeView/assets",
        name: "assets",
        component: assets,
    },
    {
        path: "/HomeView/order",
        name: "order",
        component: order,
    },
    {
        path: "/HomeView/personal/:e?",
        name: "personal",
        component: personal,
    },
    {
        path: "/help",
        name: "help",
        component: help,
    }, {
        path: "/help/faq",
        name: "helpFaq",
        component: helpFaq,
    }, {
        path: "/help/announcements",
        name: "helpAnnouncements",
        component: helpAnnouncements,
    }, {
        path: "/categories",
        name: "categories",
        component: categories
    },
    {
        path: "/content",
        name: "content",
        component: content
    },
    {
        path: "/rank",
        name: "rank",
        component: rank
    },
    {
        path: "/topup",
        name: "topUp",
        component: topUp
    },
    {
        path: "/withdraw",
        name: "withdraw",
        component: withdraw
    },
    {
        path: "/quotes",
        name: "quotes",
        component: quotes
    },
    {
        path: "/about",
        name: "about",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

// 需要登录的路由列表（仅限必须登录才能访问的页面）
// 注意：交易页面（现货、合约、期权）、投资页面、质押页面和盲盒页面允许未登录用户查看，但操作功能需要登录
const authRequiredRoutes = [
    '/HomeView/assets',      // 资产页面 - 需要登录
    '/HomeView/order',       // 订单页面 - 需要登录
    '/HomeView/personal',    // 个人中心 - 需要登录
    '/topup',                // 充值页面 - 需要登录
    '/withdraw',             // 提现页面 - 需要登录
    '/fund',                 // 基金页面 - 需要登录
    '/copyTraders',          // 跟单交易员 - 需要登录
    '/onePurchase'           // 一键购买 - 需要登录
    // 以下页面允许未登录用户查看，但操作功能需要登录：
    // '/spot' - 现货交易页面（允许查看，交易需登录）
    // '/futures' - 合约交易页面（允许查看，交易需登录）
    // '/flashOption' - 期权交易页面（允许查看，交易需登录）
    // '/volatilityOption' - 波动率期权页面（允许查看，交易需登录）
    // '/easyEarn' - 质押生息页面（允许查看，操作需登录）
    // '/pledge' - 质押页面（允许查看，操作需登录）
    // '/mock' - 模拟交易页面（允许查看，交易需登录）
    // '/BindBox' - 盲盒页面（允许查看，开盲盒需登录）
    // '/investment' - 投资页面（允许查看，投资操作需登录）
];

// 路由守卫：处理登录验证和权限控制
router.beforeEach((to, from, next) => {
    // 检查路由是否需要登录
    const requiresAuth = authRequiredRoutes.some(route => {
        if (route.includes(':')) {
            // 处理动态路由，如 /HomeView/personal/:e?
            const routePattern = route.replace(/:[^/]+/g, '[^/]+');
            const regex = new RegExp('^' + routePattern.replace(/\//g, '\\/') + '$');
            return regex.test(to.path);
        }
        return to.path.startsWith(route) || to.path === route;
    });
    
    if (requiresAuth) {
        // 检查是否已登录（优先从 Vuex store 读取，如果没有则从缓存读取）
        const token = util.getCache('token');
        let isLogin = store.getters.isLogin; // 从 Vuex store 读取登录状态
        
        // 如果 store 中没有登录状态，但有 token，尝试从缓存恢复
        if (!isLogin && token) {
            const userinfoStr = util.getCache('userinfo');
            if (userinfoStr) {
                try {
                    const userinfo = JSON.parse(userinfoStr);
                    // 恢复登录状态到 store
                    store.commit('userLogin', userinfo);
                    isLogin = true;
                } catch (e) {
                    // JSON 解析失败，清除无效数据
                    util.delCache('userinfo');
                    util.delCache('token');
                }
            }
        }
        
        if (!token || !isLogin) {
            // 未登录，跳转到登录页
            if (process.env.NODE_ENV === 'development') {
                console.log('🔐 需要登录，跳转到登录页面', { 
                    path: to.path, 
                    hasToken: !!token, 
                    isLogin,
                    storeState: store.state.userinfo !== false
                });
            }
            next({
                path: '/login',
                query: { redirect: to.fullPath } // 保存原始路径，登录后可以跳转回来
            });
        } else {
            // 已登录，允许访问
            next();
        }
    } else {
        // 公开页面，直接允许访问
        next();
    }
});

// 路由错误处理
router.onError((error) => {
    console.error('❌ 路由错误:', error);
    // 可以在这里添加错误上报逻辑
});

export default router;
